export const replaceBaseUrl = (
  originalUrl: string,
  newBaseUrl: string
): string => {
  if (!originalUrl) return originalUrl;
  const regex = /^(https?:\/\/[^/]+)(.*)$/;
  const match = originalUrl.match(regex);
  if (!match) return originalUrl;
  return `${newBaseUrl}${match[2]}`;
};

export const extractSubdomainfromUrl = (url: string): string => {
  try {
    const { hostname } = new URL(url);
    if (!hostname) return '';
    const parts = hostname.split('.');
    if (parts.length > 2) {
      const subdomain = parts[0];
      return subdomain.charAt(0).toUpperCase() + subdomain.slice(1);
    }
    return '';
  } catch {
    return '';
  }
};

export const removeTrailingSlashes = (value: string | null | undefined) => {
  if (!(typeof value === 'string')) {
    return null;
  }
  return value.replace(/\/+$/, '');
};

export const getIsPublicApplicationViewFromRouterAsPath = (asPath: string) => {
  const withoutTrailingSlashes = removeTrailingSlashes(asPath);
  if (!withoutTrailingSlashes) {
    return false;
  }
  const fakeFullUrl = `https://example.com${withoutTrailingSlashes}`;
  const ulrObj = new URL(fakeFullUrl);
  const pathname = ulrObj?.pathname;
  if (!pathname) {
    return false;
  }

  const result = pathname.replace(/\/[^/]*$/, '');

  return result === '/apps';
};
